import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';

export interface KolkataCarouselCard {
  name: string;
  desc: string;
  img?: string;
  alt?: string;
}

let nextId = 0;

/**
 * Treatment card slider using the same Swiper setup as the /treatments page:
 * autoplay every 3s (pauses on hover), 1s speed, 20px gap, 1 / 2 / 3 cards per view,
 * looping with arrows when there are more than 3 cards, static centred cards otherwise.
 */
@Component({
  selector: 'app-kolkata-treatment-carousel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kolkata-treatment-carousel.html',
  styleUrl: './kolkata-treatment-carousel.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: { ngSkipHydration: 'true' },
})
export class KolkataTreatmentCarousel implements AfterViewInit {
  @Input() cards: KolkataCarouselCard[] = [];
  @ViewChild('swiper') swiperRef?: ElementRef;

  readonly uid = nextId++;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  get useSlider(): boolean {
    return this.cards.length > 3;
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId) || !this.useSlider || !this.swiperRef) return;

    import('swiper/element/bundle').then(({ register }) => {
      register();
      const el: any = this.swiperRef!.nativeElement;
      if (el.swiper) return;

      Object.assign(el, {
        loop: true,
        speed: 1000,
        spaceBetween: 20,
        autoplay: { delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true },
        navigation: { prevEl: `.kc-prev-${this.uid}`, nextEl: `.kc-next-${this.uid}` },
        pagination: false,
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 3 },
        },
      });
      el.initialize();
      el.setAttribute('data-ready', 'true');
    });
  }

  trackByName(_i: number, c: KolkataCarouselCard): string {
    return c.name;
  }
}
